export default "/kiban/_next/static/images/jumpVcutCnt-1bc1b21c8609d67d21f9ab21fef17e8f.png";